/**
 * Filtre işlemleri için yardımcı fonksiyonlar
 */

import { FILTER_PARAMS, DEFAULT_FILTER_STATE } from '../constants/filterConstants';

/**
 * HomePage filtre formatını standart uygulama filtre formatına dönüştürür
 * type ve bodyType uyumsuzluğunu ve diğer gerekli dönüşümleri yönetir
 * 
 * @param {Object} homePageFilters - HomePage bileşeninden gelen filtre nesnesi
 * @returns {Object} - Standardize edilmiş filtre nesnesi
 */
export const standardizeHomePageFilters = (homePageFilters) => {
    const standardizedFilters = { ...homePageFilters };

    // type ve bodyType uyumsuzluğunu yönet
    if (standardizedFilters.type !== undefined) {
        standardizedFilters[FILTER_PARAMS.BODY_TYPE] = standardizedFilters.type.toLowerCase();
        delete standardizedFilters.type;
    }

    console.log("Standardized filters:", standardizedFilters);
    return standardizedFilters;
};

/**
 * URL query parametrelerini filtre nesnesine dönüştürür
 * Sabitlerden standart filtre parametre adlarını kullanır
 * 
 * @param {URLSearchParams} searchParams - URL arama parametreleri 
 * @returns {Object} - Ayrıştırılmış parametrelerle filtre nesnesi
 */
export const parseUrlParamsToFilters = (searchParams) => {
    const filters = { ...DEFAULT_FILTER_STATE };

    console.log("Parsing URL params:", Object.fromEntries(searchParams.entries()));

    // Her bir parametreyi ilgili filtre özelliğine eşle
    Object.values(FILTER_PARAMS).forEach(param => {
        const value = searchParams.get(param);
        if (value) {
            // bodyType için değeri küçük harfe çevir
            if (param === FILTER_PARAMS.BODY_TYPE) {
                filters[param] = value.toLowerCase();
                console.log(`Set bodyType = ${value.toLowerCase()} (original: ${value})`);
            } else {
                filters[param] = value;
            }
        }
    });

    console.log("Parsed filters result:", filters);
    return filters;
};

/**
 * Filtre nesnesini URL query parametrelerine dönüştürür
 * Boş değerleri filtreleyerek temiz bir URL oluşturur
 * 
 * @param {Object} filters - Dönüştürülecek filtre nesnesi
 * @returns {URLSearchParams} - URL arama parametreleri nesnesi
 */
export const filtersToUrlParams = (filters) => {
    // Boş değerleri filtrele
    const validFilters = Object.entries(filters)
        .filter(([_, value]) => value !== '')
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    console.log("Valid filters for URL:", validFilters);
    return new URLSearchParams(validFilters);
};

/**
 * Temiz bir filtre nesnesi döndürür (sadece boş olmayan değerlerle)
 * API çağrıları için kullanışlı
 * 
 * @param {Object} filters - Temizlenecek filtre nesnesi
 * @returns {Object} - Boş olmayan değerlerle temiz filtre nesnesi
 */
export const getCleanFilters = (filters) => {
    const cleanFilters = Object.entries(filters)
        .filter(([_, value]) => value !== '')
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    console.log("Clean filters for API call:", cleanFilters);
    return cleanFilters;
};